import React, { useMemo, useState } from "react";
import { VsiBubble, VsiH4, VsiH5 } from "../../styled/App.styled";
import { Card, Row, Col, ButtonGroup, Button } from "reactstrap";
import { useVsiAppContext } from "../../stores/VsiApp";
import Grid from "../../components/Grid";
import { useDataWithRoute } from "../../utils/hooks";
import { dirColumnDefs, logsDefs } from "../../utils/gridColumnDefs/admin/dataIntegrityDefs";
import BarChart from "../../components/BarChart";
import { vsiGreen, vsiRed } from "../../utils/themeStyles";

const categories = ["Incomplete", "Complete"];
const contexts = [
  "Storage",
  "Virtual",
  "Switch",
  "File",
  "Cloud",
  "Database"
];

export default function DataIntegrityReport() {
  const { theme, client } = useVsiAppContext();

  const [data, { isLoading }] = useDataWithRoute(`/api/v6/admin/data-integrity-report/${client.clientId}`);
  const [dataIntegrityData, logsData] = data?.recordsets ?? [[], []];
  const [timeFrame, setTimeFrame] = useState(0);

  const chartSeries = useMemo(() => {
    return isLoading || dataIntegrityData.length !== 3 ? [] : categories.map(cat => ({
      name: cat,
      data: contexts.map(con => dataIntegrityData[timeFrame][`${con.toLowerCase()}Devices${cat}`]),
      color: cat === "Complete" ? vsiGreen : vsiRed
    }));
  }, [isLoading, dataIntegrityData, timeFrame]);

  return (
    <Card className={`report-card p-2 nav-card-${theme}`}>
      <VsiH4>Data Integrity Report - {client.name}</VsiH4>
      <VsiBubble>
        <ButtonGroup>
          <Button active={timeFrame === 0}
                  disabled={timeFrame === 0}
                  onClick={() => setTimeFrame(0)}>Total</Button>
          <Button active={timeFrame === 1}
                  disabled={timeFrame === 1}
                  onClick={() => setTimeFrame(1)}>Daily</Button>
          <Button active={timeFrame === 2}
                  disabled={timeFrame === 2}
                  onClick={() => setTimeFrame(2)}>Weekly</Button>
        </ButtonGroup>
        <BarChart categories={contexts}
                  title={"Collection Status by Context"}
                  disableLegend={false}
                  yAxisTitle={"Devices"}
                  yAxis={{
                    allowDecimals: false,
                  }}
                  series={chartSeries} />
      </VsiBubble>
      <VsiBubble>
        <Row>
          <Col sm={12} md={6}>
            <VsiH5>Total Collection Device Completion vs Definition</VsiH5>
            <Grid isLoading={isLoading}
                  columnDefs={dirColumnDefs}
                  saveParams={{
                    unit: 'integrity'
                  }}
                  data={dataIntegrityData} />
          </Col>
          <Col sm={12} md={6}>
            <VsiH5>Devices Without Collection Today</VsiH5>
            <Grid isLoading={isLoading}
                  columnDefs={logsDefs}
                  saveParams={{
                    unit: 'logs'
                  }}
                  data={logsData} />
          </Col>
        </Row>
      </VsiBubble>
    </Card>
  );
}